<template>
  <tr>
    <th scope="row">
      <div class="d-flex align-items-center">
        {{ subCompetence.name }}
        <i
          v-if="subCompetence.devicon"
          style="margin-left: auto"
          :class="`devicon-${subCompetence.devicon}-plain colored`"
        ></i>
        <i
          v-else
          style="margin-left: auto"
          :class="`devicon-${subCompetence.name}-plain colored`"
        ></i>
      </div>
    </th>
    <td>Candidates: {{ subCompetence.candidates_count }}</td>
    <td>Job positions: {{ subCompetence.jobad_count }}</td>
    <td>Icon name: {{ subCompetence.devicon }}</td>
    <td class="text-right">
      <button class="btn btn-link" data-toggle="modal" :href="`#editModal-${subCompetence.id}`">
        <svgHelper class="edit" name="edit" />
      </button>
      <button
        style="color: #666;"
        class="btn btn-link"
        data-toggle="modal"
        :href="`#moveCompetenceModal-${subCompetence.id}`"
      >
        <i class="fas fa-exchange-alt"></i>
      </button>
      <button class="btn btn-link" data-toggle="modal" :href="`#deleteModal-${subCompetence.id}`">
        <svgHelper name="delete"></svgHelper>
      </button>
    </td>
    <div
      class="modal fade"
      :id="`moveCompetenceModal-${subCompetence.id}`"
      tabindex="-1"
      aria-labelledby="moveCompetenceModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="subCompetenceModalLabels">Move competence</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeMove"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group m-label-left">
              <input
                class="form-control"
                id="current"
                type="text"
                :placeholder="mainComp.name"
                readonly
              />
              <label for="current">Current Main Competence</label>
            </div>
            <div class="d-flex align-items-center">
              <div class="form-group m-label-left" style="width: 100%">
                <v-select
                  v-model="selectedCompetence"
                  @search="getCompetences"
                  :options="competenceResults"
                  label="name"
                  :reduce="competence => competence"
                  :clearable="false"
                >
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching && search.length >= 3">
                      No results found for <em>{{ search }}</em
                      >.
                    </template>
                    <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                  </template>
                </v-select>
                <label for="candidatew">Search competence</label>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="moveCompetence(subCompetence.id)" type="button" class="btn btn-primary">
              Confirm
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade edit-modal"
      :id="`editModal-${subCompetence.id}`"
      tabindex="-1"
      aria-labelledby="editModal2"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="`editModal2Label-${subCompetence.id}`">Edit Competence</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="">
              <div class="form-group flex-grow-1 m-label-left">
                <input
                  v-model="editMainCompetenceName"
                  type="text"
                  class="form-control"
                  id="competence"
                  name="competence"
                  placeholder="Name"
                />
                <label for="competence">Sub Competence Name</label>
              </div>
              <div class="form-group flex-grow-1 m-label-left">
                <input
                  v-model="editCompetenceIcon"
                  type="text"
                  class="form-control"
                  id="icon"
                  name="competence"
                />
                <label for="icon">Competence Icon</label>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              @click="editCompetence(editMainCompetenceName, subCompetence.id)"
              type="button"
              class="btn btn-primary"
            >
              Save changes
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade edit-modal"
      :id="`deleteModal-${subCompetence.id}`"
      tabindex="-1"
      aria-labelledby="deleteModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">Delete Competence</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeDelete"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <p>
              Please confirm that you want to delete <strong>{{ subCompetence.name }}</strong>
            </p>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              @click="deleteCompetence(subCompetence.id)"
              type="button"
              class="btn btn-primary"
            >
              Confirm
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </tr>
</template>
<script>
import axios from 'axios';
export default {
  props: {
    subCompetence: Object,
    mainComp: Object,
  },
  data: () => ({
    editMainCompetenceName: '',
    editCompetenceIcon: '',
    selectedCompetence: {},
    competenceResults: [],
  }),
  methods: {
    getCompetences(search, loading) {
      loading(true);
      axios(`${process.env.VUE_APP_API_URL}/common/competence/all`, {
        method: 'post',
        data: {
          page: 1,
          count: 200000,
          search_word: search,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          this.competenceResults = response.data.data;
          loading(false);
        })
        .catch(() => {
          loading(false);
        });
    },

    editCompetence(name, id) {
      axios(`${process.env.VUE_APP_API_URL}/common/competence/update`, {
        method: 'post',
        data: {
          name: name,
          competence_id: id,
          devicon: this.editCompetenceIcon,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$emit('move');
          this.$refs.close.click();
          this.$toasted.success('Competence successfully edited.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.$toasted.error(err.response.data, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    moveCompetence(id) {
      axios(`${process.env.VUE_APP_API_URL}/common/competence/update`, {
        method: 'post',
        data: {
          parent_id: this.selectedCompetence.id,
          competence_id: id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$refs.closeMove.click();
          this.$emit('move');
          this.$toasted.success('Competence moved successfully.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.$toasted.success(err.response.data, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    deleteCompetence(id) {
      axios(`${process.env.VUE_APP_API_URL}/common/competence/delete`, {
        method: 'delete',
        data: {
          competence_id: id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(() => {
        this.$emit('move');
        this.$refs.closeDelete.click();
        this.$toasted.success('Competence deleted successfully.', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      });
    },
  },
  mounted() {
    this.editMainCompetenceName = this.subCompetence.name;
    this.editCompetenceIcon = this.subCompetence.devicon;
  },
};
</script>
<style lang="scss" scoped>
.edit {
  fill: #666;
}
</style>
